import Box from '@mui/material/Box';
import { Logo } from '../Logo';
import Typography from '@mui/material/Typography';
import { useMobile } from 'src/hooks/useMobile';

export function HeaderLogo() {
  const isMobile = useMobile();
  return (
    <>
      <Box
        sx={{
          mr: 1.5,
        }}
      >
        <Logo width={40} height={40} asLink={true} />
      </Box>
      {!isMobile && (
        <Typography
          color="text.primary"
          variant={'h6'}
          sx={{ mr: 4, p: { lg: 2 }, whiteSpace: 'nowrap' }}
        >
          Own Your Game
        </Typography>
      )}
    </>
  );
}
